import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import AnalysisPage from './AnalysisPage';
import TestRigPage from './TestRigPage';
import HistoryPage from './HistoryPage';
import AnnotationPage from './AnnotationPage';
import AnalyzeWebsitePage from './AnalyzeWebsitePage';
import LoginGate from './LoginGate';
import { RuntimeSettingsProvider } from './context/RuntimeSettingsContext';

function App() {
  return (
    <LoginGate>
      <RuntimeSettingsProvider>
        <Router>
          <div className="min-h-screen bg-slate-100">
            <nav className="bg-white shadow-sm mb-4 sm:mb-8">
              <div className="max-w-4xl mx-auto px-3 sm:px-4 py-3 sm:py-4 flex justify-between items-center">
                <Link to="/" className="font-bold text-lg sm:text-xl text-blue-600">Auction.ai</Link>
                <div className="space-x-3 sm:space-x-6">
                  <Link to="/history" className="text-sm sm:text-base text-slate-600 hover:text-blue-600">History</Link>
                  <Link to="/test-rig" className="text-sm sm:text-base text-slate-600 hover:text-blue-600">Test Rig</Link>
                  <Link to="/annotation" className="text-sm sm:text-base text-slate-600 hover:text-blue-600">Annotation tool</Link>
                  <Link to="/analyze-website" className="text-sm sm:text-base text-slate-600 hover:text-blue-600">Analyse web-site</Link>
                </div>
              </div>
            </nav>

            <main className="container mx-auto px-2 sm:px-4 pb-8 sm:pb-12">
              <Routes>
                <Route path="/" element={<AnalysisPage />} />
                <Route path="/test-rig" element={<TestRigPage />} />
                <Route path="/history" element={<HistoryPage />} />
                <Route path="/annotation" element={<AnnotationPage />} />
                <Route path="/analyze-website" element={<AnalyzeWebsitePage />} />
              </Routes>
            </main>
          </div>
        </Router>
      </RuntimeSettingsProvider>
    </LoginGate>
  );
}

export default App;
